import axios from "axios";
import Cookies from "js-cookie";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

let isRefreshing = false;
let failedQueue: any[] = [];
let pendingToken: string | null = null; // ذخیره توکن جدید

const processQueue = (error: any, token: string | null = null) => {
  failedQueue.forEach((prom: any) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};
axiosInstance.interceptors.request.use(
  (config) => {
    const token = pendingToken || Cookies.get("token"); // از pendingToken استفاده کن
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 402 && !originalRequest._retry) {
      originalRequest._retry = true;

      if (isRefreshing) {
        // منتظر توکن جدید بمان
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = `Bearer ${token}`;
            return axiosInstance(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      isRefreshing = true;

      try {
        const refreshToken = Cookies.get("refreshToken");
        if (!refreshToken) {
          throw new Error("No refresh token available");
        }

        // دریافت توکن جدید
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/auth/refresh-token`,
          {
            headers: {
              Authorization: `Bearer ${refreshToken}`,
            },
          }
        );

        const newToken = response.data;

        pendingToken = newToken; // ذخیره توکن جدید در pendingToken
        Cookies.set("token", newToken, { expires: 7 });

        processQueue(null, newToken); // ارسال توکن جدید به صف درخواست‌ها

        originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
        return axiosInstance(originalRequest);
      } catch (err) {
        processQueue(err, null);
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
        pendingToken = null; // بازنشانی pendingToken
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
